export const formatISODateToCustomFormat = (
  isoDate: string,
  showSeconds: boolean = false
) => {
  const date = new Date(isoDate);

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  if (showSeconds) {
    options.second = '2-digit';
  }

  const formattedDate = date.toLocaleString('ru-RU', options);

  return formattedDate.replace(/ г\./, '');
};
